export default "__VITE_ASSET__CdLzXN2J__"